export function checkMinimalSearchVisibility(): boolean {
    const minimalSearchContainer = document.querySelector('.headerSearch--minimal');
    if (!minimalSearchContainer) return false;

    const computedStyle = window.getComputedStyle(minimalSearchContainer);
    return computedStyle.display !== 'none';
}

export function setupMinimalSearchObserver(callback: (isVisible: boolean) => void): () => void {
    const minimalSearchContainer = document.querySelector('.headerSearch--minimal');
    if (!minimalSearchContainer) return () => {};

    const checkAndCallback = () => {
        const isVisible = checkMinimalSearchVisibility();
        callback(isVisible);
    };

    checkAndCallback();

    const resizeObserver = new ResizeObserver(checkAndCallback);
    resizeObserver.observe(minimalSearchContainer);

    const headerElement = document.querySelector('.headerMain');
    let mutationObserver: MutationObserver | null = null;

    if (headerElement) {
        mutationObserver = new MutationObserver(() => {
            setTimeout(checkAndCallback, 10);
        });
        mutationObserver.observe(headerElement, {
            attributes: true,
            attributeFilter: ['class']
        });
    }

    window.addEventListener('resize', checkAndCallback);

    return () => {
        resizeObserver.disconnect();
        if (mutationObserver) {
            mutationObserver.disconnect();
        }
        window.removeEventListener('resize', checkAndCallback);
    };
}

export function initializeHeaderSearchIntegration() {
    let isMinimalVisible = false;
    let minimalClickHandler: ((e: Event) => void) | null = null;

    const openAutocompleteModal = () => {
        const autocompleteElement = document.getElementById('algolia-autocomplete');
        if (!autocompleteElement) return;

        const event = new CustomEvent('openAutocompleteModal', {
            bubbles: true,
            detail: { openedFromMinimalButton: true }
        });

        autocompleteElement.dispatchEvent(event);
    };

    const updateEventListeners = (newVisibility: boolean) => {
        if (newVisibility === isMinimalVisible) return;

        isMinimalVisible = newVisibility;
        const minimalSearchContainer = document.querySelector('.headerSearch--minimal');
        const minimalSearchButton = minimalSearchContainer?.querySelector('.iconbarIcon--searchMinimal');

        if (!minimalSearchButton) return;

        if (minimalClickHandler) {
            minimalSearchButton.removeEventListener('click', minimalClickHandler);
            minimalClickHandler = null;
        }

        if (isMinimalVisible) {
            minimalClickHandler = (e) => {
                e.preventDefault();
                e.stopPropagation();
                openAutocompleteModal();
            };
            minimalSearchButton.addEventListener('click', minimalClickHandler);
        }
    };

    setupMinimalSearchObserver(updateEventListeners);
}